import { Box, Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { RibbonCard } from '@/components/layout/RibbonCard';
import { useFormContext } from '@/components/react-hook-form';
import { MultiDocumentUploaderWithListV2 } from '@/modules/documents/MultiDocumentUploader/MultiDocumentUploaderWithListV2';

import { ILITTaskContext } from '../ILITTaskContext';
import { ILITMakeAnnualExclusionGiftsForm } from './ILITMakeAnnualExclusionGiftsTask.types';
import { ILITMakeAnnualGrantorGift } from './ILITMakeAnnualGrantorGift/ILITMakeAnnualGrantorGift';

export function ILITMakeAnnualExclusionGiftsTaskBody() {
  const { householdId } = useContext(ILITTaskContext);
  const { control } = useFormContext<ILITMakeAnnualExclusionGiftsForm>();

  const grantors = useWatch<ILITMakeAnnualExclusionGiftsForm>({
    name: 'grantors',
    control,
  }) as ILITMakeAnnualExclusionGiftsForm['grantors'];

  return (
    <Stack>
      <RibbonCard
        heading="Confirm gifted amounts"
        rightHeaderContent={
          <Typography variant="body-xs">
            Source value after gift is optional
          </Typography>
        }
      >
        <Stack direction="column" spacing={6}>
          {Object.values(grantors)?.map((grantor, index) => (
            <ILITMakeAnnualGrantorGift
              grantor={grantor}
              key={`grantor-${index}`}
            />
          ))}
          <Box sx={{ py: 2, px: 10 }}>
            <MultiDocumentUploaderWithListV2
              householdId={householdId}
              variant="compact"
            />
          </Box>
        </Stack>
      </RibbonCard>
    </Stack>
  );
}
